import React, { useEffect, useState } from 'react';
import { Phone, MessageSquare } from 'lucide-react';

// Show the floating CTA only after the user has scrolled past the hero,
// so on mobile it stops overlapping the hero search bar / valuation form.
const SHOW_AFTER_PX = 600;

export const FloatingCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SHOW_AFTER_PX);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-4 left-4 sm:bottom-6 sm:left-6 z-[90] flex flex-col items-start space-y-3 transition-all duration-300 ${
        visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
      data-testid="floating-cta"
      aria-hidden={!visible}
    >
      <a
        href="tel:252-564-5612"
        data-testid="floating-call-cta"
        aria-label="Call Jess Now at 252-564-5612"
        className="group flex items-center bg-gradient-to-r from-gold-400 to-gold-500 hover:from-gold-300 hover:to-gold-400 text-[#143160] rounded-full font-bold shadow-2xl hover:scale-105 transition-all duration-300 animate-bounce-slow h-14 sm:h-auto sm:space-x-3 sm:px-5 sm:py-4"
        style={{ boxShadow: '0 8px 32px rgba(250, 204, 21, 0.4), 0 4px 16px rgba(0,0,0,0.2)' }}
      >
        <div className="w-14 h-14 sm:w-12 sm:h-12 bg-[#143160] rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-[#1E4A86] transition-colors">
          <Phone className="w-6 h-6 text-gold-400 animate-pulse" />
        </div>
        <div className="hidden sm:block pr-2">
          <p className="text-xs font-semibold uppercase tracking-wide">Call Jess Now!</p>
          <p className="text-lg font-black">252-564-5612</p>
        </div>
      </a>

      <a
        href="sms:252-564-5612"
        data-testid="floating-text-cta"
        aria-label="Text Jess at 252-564-5612"
        className="flex items-center justify-center bg-white/95 backdrop-blur-sm text-[#143160] rounded-full font-semibold shadow-lg hover:scale-105 transition-all border-2 border-gold-400 w-14 h-14 sm:w-auto sm:h-auto sm:min-h-[44px] sm:px-4 sm:space-x-2"
      >
        <MessageSquare className="w-5 h-5" />
        <span className="hidden sm:inline text-sm">Text Jess</span>
      </a>
    </div>
  );
};
